import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
    {
        path: '/freelogin',
        name: 'freelogin',
        component: resolve =>
            require(["../views/freeLogin.vue"], resolve)
    },
    {
        path: '/thirdoauth',
        name: 'thirdoauth',
        component: resolve =>
            require(["../views/thirdOauth.vue"], resolve)
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

export default router;

